import { Grid, Input, InputWrapperProps, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import {
  type Control,
  Controller,
  type UseFormRegister,
} from "react-hook-form";
import { type IUserForm } from "src/pages/Settings/CrewSetUp/UserForm/UserForm.types";
import { InputStyledWrapper } from "src/styled/UserForm.styled";
import { toMantineDateString } from "src/utils/mantineDates";

interface Props {
  register: UseFormRegister<IUserForm>;
  control: Control<IUserForm>;
}

const InputWrapper = (props: InputWrapperProps) => {
  return (
    <InputStyledWrapper style={{ width: "unset" }} {...props}>
      {props.children}
    </InputStyledWrapper>
  );
};

const Col = (props: any) => {
  return (
    <Grid.Col {...props}>
      <InputWrapper>{props.children}</InputWrapper>
    </Grid.Col>
  );
};

/** Protected info for a user being created; sent with save-user as `protectedData`. */
const NewUserProtectedInfo = ({ register, control }: Props) => {
  return (
    <Grid gutter="sm">
      <Col>
        <Text fz={"sm"}>Date of Birth</Text>
        <Controller
          name="protectedData.dob"
          control={control}
          render={({ field }) => (
            <DateInput
              w={"50%"}
              value={toMantineDateString(field.value)}
              onChange={value => field.onChange(value ?? "")}
              onBlur={field.onBlur}
              valueFormat="DD MMM YYYY"
              clearable
            />
          )}
        />
      </Col>

      <Col>
        <Text fz={"sm"}>Address</Text>
        <Input w={"50%"} {...register("protectedData.address")} />
      </Col>

      <Col>
        <Text fz={"sm"}>Next of Kin</Text>
        <Input w={"50%"} {...register("protectedData.nextOfKin")} />
      </Col>
    </Grid>
  );
};

export default NewUserProtectedInfo;
